//TODO: Make sure more feeds are loaded on infinite scroll

import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FilterByCriteria } from '@innovation-os-ng/common';
import { PermissionService, PermissionVerbsV2 } from '@innovation-os-ng/core/core';
import { MenuContainerModule } from '@innovation-os-ng/ui/menu-container';
import { Ui2ButtonModule } from '@innovation-os-ng/ui/ui2-button';
import { Ui2SearchModule } from '@innovation-os-ng/ui/ui2-search';
import { CompoundFilter } from '@itonics/filters';
import { Subscription } from 'rxjs';
import { SortListComponent } from '../../../sort-list/sort-list.component';
import { EntityFragment } from '../../interfaces/entity';
import { Action, FeedEvaluationBasis, SearchField, SignalFilterOption, SortOption } from '../../interfaces/feed';
import { FilterDropdownComponent } from '../feed-filters/filter-dropdown/filter-dropdown.component';
import { SourceFromFilterComponent } from '../feed-filters/filter-source/filter-source.component';
import { RefineFeedCtaComponent } from '../refine-feed-cta/refine-feed-cta.component';
import { SearchFieldSelectorV2Component } from '../search-field-selector/search-field-selector.component';

const SEARCH_INPUT_FADE_IN = 500;
const SEARCH_INPUT_FADE_OUT = 200;
@Component({
  selector: 'signals-news-feed-header',
  templateUrl: './news-feed-header.component.html',
  styleUrls: ['./news-feed-header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RefineFeedCtaComponent,
    Ui2ButtonModule,
    MenuContainerModule,
    FilterDropdownComponent,
    SourceFromFilterComponent,
    SearchFieldSelectorV2Component,
    SortListComponent,
    Ui2SearchModule
  ]
})
export class NewsFeedHeaderComponent implements OnInit, OnDestroy {
  @Input()
  public filter: CompoundFilter;

  @Input()
  public isFact: boolean = false;

  @Input()
  public filterIdentifier: string;

  @Input()
  public filterBy: FilterByCriteria;

  @Input()
  public signalsFilterActions: Array<Action>;

  @Input()
  public signalsUris: Array<string>;

  @Input()
  public isLoadingFeed: boolean;

  @Input()
  public tooltipRefineFeed: string;

  @Input()
  public subscriptionToInsights: boolean;

  @Input()
  public evaluationBasis: FeedEvaluationBasis;

  @Input()
  public element: EntityFragment;

  @Input()
  public linkedSearchField: SearchField;

  @Input()
  public onlyShowExplicitSearchFields: boolean;

  // Contextual copy to use in this component (defaults exist)
  @Input()
  public copyOverrides: { [key: string]: string };

  // If true, only the 'view in insights' interaction is allowed
  // regardless of the user's premissions
  @Input()
  public viewOnly: boolean;

  @Output()
  public onLinkedSearchFieldCreated: EventEmitter<SearchField> = new EventEmitter<SearchField>();

  @Output()
  signalsFilterSelection: EventEmitter<{ option: SignalFilterOption; uris: Array<string> }> = new EventEmitter();

  @Output()
  sourceFilterSelection: EventEmitter<string> = new EventEmitter();

  @Output()
  typeFilterSelection: EventEmitter<Array<string>> = new EventEmitter();

  @Output()
  sort: EventEmitter<SortOption> = new EventEmitter();

  @Output()
  search: EventEmitter<string> = new EventEmitter();

  @Output()
  searchFieldSelection: EventEmitter<SearchField> = new EventEmitter();

  public searchQuery: string;
  public toggleSearch: boolean;
  public focus: boolean;

  public selectedSearchField: SearchField;
  public showSearchFieldSelector: boolean;
  private permissionCheckSub: Subscription;
  public viewInsightPermission: boolean;

  constructor(private readonly permissionService: PermissionService) {}

  ngOnInit(): void {
    this.permissionCheckSub = this.permissionService.userHasPermission(PermissionVerbsV2.VIEW_INSIGHTS_MODULE).subscribe((permission) => {
      this.viewInsightPermission = permission;
    });
  }

  ngOnDestroy(): void {
    this.permissionCheckSub?.unsubscribe();
  }

  public onToggleSearch() {
    this.toggleSearch = !this.toggleSearch;

    /*
      We want to focus/blur the search input after the transition
    */
    setTimeout(
      () => {
        this.focus = !!this.toggleSearch;
      },
      this.toggleSearch ? SEARCH_INPUT_FADE_IN : SEARCH_INPUT_FADE_OUT
    );
  }

  public searchFieldSelectorReady(items: Array<SearchField>) {
    // If there is no data we don't render this selector
    this.showSearchFieldSelector = !!items.length;
  }

  public onSearchFieldSelected(searchField: SearchField) {
    this.selectedSearchField = searchField;
    this.searchFieldSelection.emit(searchField);
  }
}
